export default __webpack_public_path__ + "static/media/user.c1f8e481.png";